export default __webpack_public_path__ + "static/media/ERIC TACHIE YEBOAH CV1- 2020.1a30042e.pdf";